import React from 'react';
import { Box, Container, useTheme, useMediaQuery } from '@mui/material';

const ResponsiveLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
        padding: 0,
        margin: 0,
      }}
    >
      <Container
        maxWidth={false}
        disableGutters
        sx={{
          height: '100%',
          padding: 0,
          margin: 0,
          '& .MuiContainer-root': {
            padding: 0,
            margin: 0,
          }
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default ResponsiveLayout; 